
import Loading from './../../../Loading';
import { useState } from 'react';
import { useEffect } from 'react';

const CatsPost = ({ data, pullback, checked }) => {

     const [checkedState, setCheckedState] = useState([])


     useEffect(() => {
          checked && setCheckedState(checked)
     }, [checked])


     const handleOnChangeCheckBoxs = (event) => {
          let val = parseInt(event.target.value)

          if (event.target.checked) {
               setCheckedState(prev => [...prev, val])
               pullback(prev => [...prev, val])
          } else {

               let arryCopy = [...checkedState]
               const index = arryCopy.indexOf(val);
               if (index > -1) {
                    arryCopy.splice(index, 1);
                    setCheckedState(arryCopy)
                    pullback(arryCopy)
               }

          }
     }




     return (
          <div className="boxHolderPosts">
               <div className="titleBar">دسته بندی ها</div>
               <div className="boxPost">
                    <ul>
                         {data ? data.map((i) => (
                              <li key={i.id}><label htmlFor={i.id}><input type="checkbox" value={i.id} defaultChecked={checked && checked.includes(i.id) && 'checked'} onChange={handleOnChangeCheckBoxs} name={i.id} id={i.id} />{i.parentId == null ? (<b>{i.title}</b>) : i.title}</label>

                                   {i.child && (
                                        <ul style={{ marginRight: '20px' }}>
                                             {i.child.map(child => (
                                                  <li key={child.id}><label htmlFor={child.id}><input type="checkbox" value={child.id} defaultChecked={checked && checked.includes(child.id) && 'checked'} onChange={handleOnChangeCheckBoxs} name={child.id} id={child.id} />{child.parentId == null ? (<b>{child.title}</b>) : child.title}</label></li>
                                             ))}
                                        </ul>
                                   )}

                              </li>
                         )) : <Loading styles='mini' />}
                    </ul>
               </div>
          </div>

     )
}

export default CatsPost